export function getColumnWidth(
  areaWidth: number,
  optionsCount: number,
  additionalWidth = 0,
  padding = 8,
): number {
  return Math.floor((areaWidth - additionalWidth - padding * 2) / optionsCount);
}

export function getColumnOptions(width: number) {
  return {
    width: `${width}px`,
    maxWidth: `${width}px`,
    minWidth: `${width}px`,
  };
}
